// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fF","advertDetailContactGroup__header":"c-n_fG","advertDetailContactGroup__value":"c-n_fH"};